import * as React from 'react';
import { Card, CardContent } from './card';
import { cn } from '../../lib/utils';

/**
 * Reusable KPI tile.
 * <StatTile label="Online" value={12} icon={CheckCircle} tone="success" />
 */
const tones = {
  default: 'bg-muted text-muted-foreground',
  primary: 'bg-primary/10 text-primary',
  success: 'bg-success/10 text-success',
  warning: 'bg-warning/10 text-warning',
  destructive: 'bg-destructive/10 text-destructive',
};

function StatTile({ label, value, icon: Icon, tone = 'default', hint, className }) {
  return (
    <Card className={cn('overflow-hidden', className)}>
      <CardContent className="flex items-start justify-between p-5">
        <div className="flex flex-col gap-1">
          <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
            {label}
          </span>
          <span className="text-3xl font-semibold tracking-tight text-foreground tabular-nums">
            {value}
          </span>
          {hint && <span className="text-xs text-muted-foreground">{hint}</span>}
        </div>
        {Icon && (
          <div
            className={cn(
              'flex h-11 w-11 items-center justify-center rounded-xl',
              tones[tone] || tones.default
            )}
          >
            <Icon className="h-5 w-5" />
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export { StatTile };
